import { animate, state, style, transition, trigger } from '@angular/animations';

export const Animations = {
  fadeInAnimation: trigger('fadeInAnimation', [
    state('in', style({ opacity: 1 })),
    transition(':enter', [style({ opacity: 0 }), animate('450ms {{delay}}')], {
      params: { delay: '0s' },
    }),
  ]),
  fadeInOutAnimation: trigger('fadeInOutAnimation', [
    state('in', style({ opacity: 1 })),
    transition(':enter', [style({ opacity: 0 }), animate(500)]),
    transition(':leave', [style({ opacity: 1 }), animate(500, style({ opacity: 0 }))]),
  ]),
  widthAnimation: trigger('widthAnimation', [
    transition(':enter', [
      style({ width: '0', opacity: 0, overflow: 'hidden' }),
      animate('600ms ease-out', style({ width: '29.55vw', opacity: 1, overflow: 'hidden' })),
    ]),
    transition(':leave', [
      style({ width: '29.55vw', opacity: 1, overflow: 'hidden' }),
      animate('400ms ease-in', style({ width: '0', opacity: 0, overflow: 'hidden' })),
    ]),
  ]),
  riskDetailOpenAnimation: trigger('riskDetailOpenAnimation', [
    state(
      'void',
      style({
        height: '1%',
        overflow: 'hidden',
        marginTop: '0',
      })
    ),
    state(
      '*',
      style({
        height: '38vh',
        marginTop: '3px',
      })
    ),
    transition('void => *', [animate('400ms ease-out')]),
    // transition('* => void', [animate('400ms ease-in')]),
  ]),
  showMoreOpenAnimation: trigger('showMoreOpenAnimation', [
    state(
      'void',
      style({
        opacity: 0,
      })
    ),
    state(
      '*',
      style({
        opacity: 1,
      })
    ),
    transition('void => *', [animate('500ms ease-in')]),
    transition('* => void', [animate('500ms ease-out')]),
  ]),
};
